import { FaArrowRight } from 'react-icons/fa6';
var BtnArrow = function BtnArrow(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? null : _ref$onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "btn-arrow ".concat(className),
    style: style,
    onClick: function onClick() {
      if (_onClick) _onClick();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-arrow__btn"
  }, label), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FaArrowRight, null)));
};
export default BtnArrow;